// Tipi per i locali approvati

export type TipoLocale = 'ristorante' | 'trattoria' | 'agriturismo' | 'osteria' | 'pizzeria' | 'pub';

export type Provincia = 'AN' | 'PU' | 'MC' | 'FM' | 'AP';

export type FasciaPrezzo = '€' | '€€' | '€€€';

export interface Locale {
  id: number;
  slug: string;
  nome: string;
  tipo: TipoLocale;
  indirizzo: string;
  comune: string;
  provincia: Provincia;
  cap?: string;
  latitudine: number;
  longitudine: number;
  telefono?: string;
  email?: string;
  sitoWeb?: string;
  facebook?: string;
  instagram?: string;
  fasciaPrezzo?: FasciaPrezzo;
  specialita: string[];
  descrizione?: string;
  percheApprovato?: string;
  orari?: OrariApertura;
  parcheggioGrande: boolean;
  fotoPrincipale: string;
  galleria: string[];
  dataApprovazione?: string;
  inEvidenza: boolean;
  attivo: boolean;
  visite: number;
}

export interface OrariApertura {
  lunedi?: string;
  martedi?: string;
  mercoledi?: string;
  giovedi?: string;
  venerdi?: string;
  sabato?: string;
  domenica?: string;
  note?: string;
}

// Tipi per i filtri
export interface FiltriLocali {
  provincia?: Provincia;
  tipo?: TipoLocale;
  fasciaPrezzo?: FasciaPrezzo;
  ricerca?: string;
}

// Tipi per l'autenticazione (per uso futuro)
export interface Utente {
  id: number;
  email: string;
  nome: string;
  cognome?: string;
  ruolo: 'utente' | 'admin';
  avatarUrl?: string;
}

// Tipi per le segnalazioni (per uso futuro)
export interface Segnalazione {
  id: number;
  nomeLocale: string;
  tipoLocale?: TipoLocale;
  indirizzoApprossimativo?: string;
  comune?: string;
  provincia?: Provincia;
  descrizione?: string;
  specialitaSuggerite?: string;
  comeStoCoperto?: string;
  stato: 'nuova' | 'in_valutazione' | 'approvata' | 'rifiutata' | 'duplicata';
  createdAt: string;
}

// Tipi per i preferiti (per uso futuro)
export interface Favorito {
  id: number;
  localeId: number;
  notePersonali?: string;
  createdAt: string;
}

// Props comuni per i componenti
export interface LocaleCardProps {
  locale: Locale;
  onFavoritoClick?: (localeId: number) => void;
  isFavorito?: boolean;
}

export interface LocaleFiltersProps {
  filtri: FiltriLocali;
  onFiltriChange: (filtri: FiltriLocali) => void;
}

// Coordinate per la mappa
export interface Coordinate {
  lat: number;
  lng: number;
}

// Configurazione mappa
export const MAPPA_CONFIG = {
  // Centro delle Marche (Ancona)
  centro: { lat: 43.6158, lng: 13.5189 } as Coordinate,
  zoomIniziale: 9,
  zoomMin: 7,
  zoomMax: 18,
};

// Etichette per i tipi di locale
export const TIPI_LOCALE_LABELS: Record<TipoLocale, string> = {
  ristorante: 'Ristorante',
  trattoria: 'Trattoria',
  agriturismo: 'Agriturismo',
  osteria: 'Osteria',
  pizzeria: 'Pizzeria',
  pub: 'Pub',
};

// Etichette per le province
export const PROVINCE_LABELS: Record<Provincia, string> = {
  AN: 'Ancona',
  PU: 'Pesaro-Urbino',
  MC: 'Macerata',
  FM: 'Fermo',
  AP: 'Ascoli Piceno',
};
